import React from "react";
import { connect } from "react-redux";
import { getRouteClientIdParam } from "@selectors";
import * as accountSelectors from "@modules/account/selectors";
import * as clientsSelectors from "@modules/context/selectors";
import type { Client } from "@modules/context/types";
import actionCreators from "@modules/context/actionCreator";
import type { ProfileClient } from "@modules/account/types";

type PropsFromState = {
  clientId: number,
  client: Client | null,
  isFirstCareUser: boolean, // TODO check the permission selector with the BE permissions logic
  hasContextSwitch: boolean, // TODO duplicates the logic
  hasReportingContextSwitch: boolean,
  userClient: ProfileClient,
};

type PropsFromDispatch = {
  clearClientContext: typeof actionCreators.ClearClientContext,
  getClientContext: typeof actionCreators.GetClientContext,
  setClientContext: typeof actionCreators.SetClientContext,
};

type Props = {
  ...PropsFromState,
  ...PropsFromDispatch,
};

const withClientContext = (props?: Object) => {
  return (WrappedComponent: *) => {
    class WithClientContext extends React.Component<Props> {
      componentDidMount() {
        if (!this.props.clientId) {
          return;
        }

        if (
          this.props.isFirstCareUser &&
          (!this.props.client || this.props.client.id !== this.props.clientId)
        ) {
          this.props.getClientContext({ clientId: this.props.clientId });
        }

        if (
          !this.props.isFirstCareUser &&
          this.props.userClient &&
          (!this.props.client || this.props.client.id !== this.props.clientId)
        ) {
          this.props.setClientContext(this.props.userClient);
        }
      }

      render() {
        return <WrappedComponent {...props} {...this.props} />;
      }
    }

    const mapStateToProps = (state, ownProps): PropsFromState => {
      const clientId = getRouteClientIdParam(ownProps);

      return {
        clientId,
        client: clientsSelectors.getClientContext(state),
        isFirstCareUser: accountSelectors.isFirstCareUser(state),
        hasContextSwitch: accountSelectors.hasClientContextSwitch(state),
        hasReportingContextSwitch: accountSelectors.hasReportingClientContextSwitch(state),
        userClient: accountSelectors.getUserClient(state),
      };
    };

    const mapDispatchToProps: PropsFromDispatch = {
      clearClientContext: actionCreators.ClearClientContext,
      getClientContext: actionCreators.GetClientContext,
      setClientContext: actionCreators.SetClientContext,
    };

    return connect(mapStateToProps, mapDispatchToProps)(WithClientContext);
  };
};

export default withClientContext;
